import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { CopyIcon, SuccessCopyIcon } from 'modules/icons';

import { useCopyClick } from './hooks/useCopyClick';

interface ICopyProps {
  text: string;
}

export function Copy({ text }: ICopyProps): JSX.Element {
  const { classes, cx } = useStyles();

  const { isCopied, handleCopy } = useCopyClick();

  return (
    <div className={classes.root}>
      {isCopied ? (
        <SuccessCopyIcon className={classes.icon} />
      ) : (
        <CopyIcon
          className={cx(classes.icon, classes.copyIcon)}
          onClick={() => {
            handleCopy(text);
          }}
        />
      )}
    </div>
  );
}

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    width: 20,
    color: alpha(theme.palette.secondary.contrastText, 0.3),
  },

  copyIcon: {
    cursor: 'pointer',

    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));
